import dynamic from "next/dynamic";

export const JobPostContent = dynamic(() => import("./component"));
